import { useContext, useState } from 'react'
import { useCreatePlans, useFetchPlans } from '../../hooks/api'
import {
  IFetchPlansFilters,
  useDownloadPlans,
} from '../../hooks/api/users/usePlans'
import useDeleteMethod from '../../hooks/utils/useDeleteMethod'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'
import { ServiceContext } from '../../hooks/context/ServiceContext'
const usePlanLogic = () => {
  const { service } = useContext(ServiceContext)
  const [filters, setFilters] = useState<IFetchPlansFilters>({
    pageSize: 10,
    searchTerm: '',
    pageNumber: 1,
    network: service as 'mtn' | 'glo',
  })
  const handleSearchTerm = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters((prev) => ({ ...prev, searchTerm: e.target.value }))
  }
  const planList = useFetchPlans(filters)
  const downloadPlan = useDownloadPlans(filters)
  const createPlan = useCreatePlans()

  const deleteMethod = useDeleteMethod()

  const handleDelete = (id: string, service?: string) => {
    deleteMethod.handleDelete('plan', id, service)

    planList.refetch()
  }

  const handleDownload = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    toast.dismiss()
    const loading = toast.loading(`Downloading Plans`)
    return downloadPlan.mutate(undefined, {
      onSuccess: (response) => {
        saveAs(response, 'Plan.csv')
      },
      onSettled: () => {
        toast.dismiss(loading)
      },
    })
  }
  return {
    planList,
    createPlan,
    setFilters,
    handleSearchTerm,
    handleDelete,
    handleDownload,
  }
}
export default usePlanLogic
